import { connect } from 'react-redux';
import Homepage from './HomePage';

function mapStateToProps({ config, geoIp, marketing, offers }) {
  return {
    country: geoIp.geoIpInfo.country,
    imagesHost: config.imagesHost,
    offers: Object.values(offers.byId).map(offer => ({
      title: offer.details,
      logo: `//images.gasbuddy.io/autox100/${offer.partner.image_url}`,
      tags: offer.tags,
    })),
    platformTotals: marketing.platformTotals,
    savedByUser: marketing.savedByUser,
  };
}

export default connect(mapStateToProps)(Homepage);
